import api from '@/utils/api'

export const fetchPage = (slug) => {
  return api.get(`/pages/${slug}/`)
    .then(resp => {
      return (resp.data)
    })
}

export const createPlaceholder = (slug, obj) => {
  return api.post(`/pages/${slug}/placeholders/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
export const updatePlaceholder = (slug, obj) => {
  return api.put(`/pages/${slug}/placeholders/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
export const changePlaceholderPosition = (slug, pid, change) => {
  return api.put(`/pages/${slug}/placeholders/${pid}/change_position/`, change)
    .then(resp => {
      return (resp.data)
    })
}

export const deletePlaceholder = (slug, obj) => {
  return api.delete(`/pages/${slug}/placeholders/${obj.id}/`)
    .then(resp => {
      return (resp.data)
    })
}



// WEBPACK FOOTER //
// ./src/pages/api.js